module.exports = __webpack_public_path__ + "static/aida-prod-alt-gorsel-1ba9515fccc2369ad0a912a26999f501.webp";